<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div
        :class="b('title')"
        v-html="titleFormatter && titleFormatter(dataChart)"
    ></div>
    <div :ref="id" :style="MinusDrillHeightStyle"></div>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
  </div>
</template>

<script>
import create from "../../create";
import {ArrowRight} from "@element-plus/icons-vue";

export default create({
  name: "pie",
  data() {
    return {
      formatter: (params, data) => {
        let content = '';
        try {
          if (!this.option.tipContent) {
            this.option.tipContent = ['维度值', '指标名', '指标值']
          }
          if (this.option.tipContent?.includes('维度值')) {
            content += `<div>${params[0].name}</div>`
          }
          params.forEach(item => {
            content += '<div>'
            if (this.option.tipContent?.includes('指标名')) {
              content += `${item.seriesName}`
            }
            if (this.option.tipContent?.includes('指标值')) {
              if (this.option.tipContent?.includes('指标名')) {
                content += '：'
              }
              const unit = this.getUnit(item.seriesName)
              content += `${item.value}${unit}`
            }
            content += '</div>'
          })
        } catch (e) {
          console.log(e)
        }
        return content
      },
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },
  methods: {
    // 获取单位
    getUnit(name) {
      const fieldItem = this.prop.metrics.find(item => item.name === name || item.fieldName === name) || {}
      if (fieldItem?.set?.type === 'percent') {
        return '%'
      }
      return fieldItem?.set?.indexUnit || ''
    },
    updateChart() {
      console.log(this.option)
      const optionData = this.deepClone(this.dataChart) || [];
      const option = {
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip(),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        series: (() => {
          const list = [
            {
              type: "pie",
              roseType: this.option.roseType ? "radius" : "",
              radius: this.option.radius ? ["40%", "55%"] : "50%",
              center: ["50%", "60%"],
              animationType: "scale",
              animationEasing: "elasticOut",
              animationDelay: function (idx) {
                return Math.random() * 200;
              },
              label: this.getOptionLabel({
                position: this.option.labelPosition,
              }),
              labelLine: {
                show: this.option.labelContent?.includes('引导线') || true
              },
              data: (() => {
                let list = optionData;
                if (this.isDataCenter) {
                  let metrics = this.prop.metrics[0];
                  list = this.dataChart.map((_el) => {
                    return {
                      value: _el[metrics.code],
                      name: _el[this.dcode],
                      ..._el
                    };
                  });
                }
                if (this.option.notCount) {
                  list = list.filter((ele) => ele.value !== 0 && ele.value);
                }
                if (this.option.sort) {
                  list.sort((a, b) => a.value - b.value);
                }
                return list;
              })(),
              itemStyle: this.getHasProp(
                  !this.switchTheme,
                  {
                    color: (params) => this.getColor(params.dataIndex),
                  },
                  {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  }
              ),
            },
          ];
          return list;
        })(),
      };
      if (this.isDataCenter) {
        let _op = this.getDimentionOption();
        option.legend.data = _op.categories;
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  },
});
</script>



